(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  
$('.hamburger-icons').on('click', function(){
  $("#abSidenav").css({'width':'70%'});
  $('.ab-nav-item-continer').css({'opacity':'1'});
});

$('.hamburger-cross').on('click', function(){
  $("#abSidenav").css({'width':'0px'});
  $('.ab-nav-item-continer').css({'opacity':'.2'});
});

var acc = document.getElementsByClassName("ab-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}
      
      window.onscroll = function() {stickyHeader()};

var header = document.querySelector("#shopify-section-header header.site-header");

var sticky = header.offsetTop;

function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky-header");
  } else {
    header.classList.remove("sticky-header");
  }
}


  } catch(e) { console.error(e); }
})();
})();
